module.exports = __webpack_public_path__ + "img/parteneri.7cf6f4d3.png";